import Props from '@service-victoria/component-library/props';
import { FormikErrors, FormikTouched, FormikProps } from 'formik';
import { lazy } from 'react';
import * as Yup from 'yup';

import formData from 'form/formData';
import { SmallSiteStep } from 'interfaces/transaction';
import { GenericValidationErrors } from 'utils/constants';

import next from '../Review/meta';
import previous from '../YourWorkSite/meta';
import meta, { Values } from './meta';

const dataKey = 'smallSite';

const initialValues: SmallSiteStep = formData[dataKey]
  .map(({ id }) => ({ [id]: false }))
  .reduce((prev, curr) => Object.assign(prev, curr), {}) as SmallSiteStep;

const initialErrors: FormikErrors<SmallSiteStep> = {};
const initialTouched: FormikTouched<SmallSiteStep> = {};

const checkboxSchema = Yup.boolean()
  .required(GenericValidationErrors.mandatoryCheckbox)
  .test('isTicked', GenericValidationErrors.mandatoryCheckbox, function (val?: boolean) {
    return !!val;
  });

const SmallSiteSchema = Yup.object().shape<SmallSiteStep>(
  formData[dataKey]
    .map(({ id }) => ({ [id]: checkboxSchema }))
    .reduce(
      (prev, curr) => Object.assign(prev, curr),
      {}
    ) as unknown as Yup.ObjectSchemaDefinition<SmallSiteStep>
);

const validationSchema = Yup.object().shape<Values>({
  smallSite: SmallSiteSchema
}) as Yup.Schema<Values>;

const Step: Props.Wizard.Step<Values> = {
  ...meta,
  Component: lazy(() => import('./SmallSite')),
  validation: {
    schema: validationSchema,
    fieldNames: formData[dataKey].map(({ id }) => `${dataKey}.${id}`)
  },
  navigation: {
    normal: [
      {
        content: 'Next',
        shouldValidate: true,
        type: 'primary',
        onClick: (
          context: Props.Wizard.StepConsumerContext<Values>,
          form: FormikProps<Values>
        ): void => {
          context.dispatch({
            type: 'GOTO_STEP',
            stepId: next.id,
            delayedLoadingMs: 500,
            values: form.values
          });
        }
      },
      {
        content: 'Back',
        type: 'secondary',
        onClick: (context: Props.Wizard.StepConsumerContext<Values>): void => {
          context.dispatch({
            type: 'GOTO_STEP',
            stepId: previous.id,
            delayedLoadingMs: 500,
            values: undefined
          });
        }
      }
    ],
    order: 'descending'
  }
};

export { Step, initialErrors, initialTouched, initialValues, SmallSiteSchema };
